module.exports = __webpack_public_path__ + "img/solucion o jabon liquido dermico.68814913.png";